import { toast } from 'vuetify-sonner'
import 'vuetify-sonner/style.css'

function useToastFunction() {
  return toast
}

export { useToastFunction as useToast }
export default useToastFunction

